import { render } from "./HiringVehicleComponent.vue?vue&type=template&id=b124b718&scoped=true"
const script = {}

import "./HiringVehicleComponent.vue?vue&type=style&index=0&id=b124b718&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b124b718"]])

export default __exports__